import React, { useState, useRef } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice de test de vue - Calculatrice d'examen et de mesure de la vision";
const DESCRIPTION =
  "Calculatrice de test de vue - Calculatrice d en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "de test de vue d, calculatrice de test de vue d, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/eye-test/";
const lines = [
  {
    text: "E",
    size: "90px",
    value: "6/60",
    advice: "Vous devriez consulter un médecin.",
    test: "bad",
  },
  {
    text: "FP",
    size: "80px",
    value: "6/30",
    advice: "Vous devriez consulter un médecin.",
    test: "bad",
  },
  {
    text: "T O Z",
    size: "70px",
    value: "6/21",
    advice: "Vous devriez consulter un médecin.",
    test: "bad",
  },
  {
    text: "L P E D",
    size: "60px",
    value: "6/15",
    advice: "Vous devriez consulter un médecin.",
    test: "bad",
  },
  {
    text: "P E C F D",
    size: "50px",
    value: "6/12",
    advice: "Vous devriez consulter un médecin.",
    test: "bad",
  },
  {
    text: "E D F C Z P",
    size: "40px",
    value: "6/9",
    advice: "Vous devriez consulter un médecin.",
    test: "bad",
  },
  {
    text: "F E L O P Z D",
    size: "30px",
    value: "6/7.5",
    advice: "Continuez à prendre soin de la santé de vos yeux.",
    test: "good",
  },
  {
    text: "D E F P O T E C",
    size: "25px",
    value: "6/6",
    advice: "Continuez à prendre soin de la santé de vos yeux.",
    test: "good",
  },
  {
    text: "L E F O D P C T",
    size: "20px",
    value: "6/6",
    advice: "Continuez à prendre soin de la santé de vos yeux.",
    test: "good",
  },
  {
    text: "P E F C Z P T O",
    size: "15px",
    value: "6/6",
    advice: "Continuez à prendre soin de la santé de vos yeux.",
    test: "good",
  },
];
function Calculator() {
  const [result, setResult] = useState(null);
  const resultRef = useRef(null);
  const handleRowClick = (line) => {
    setResult(line);
    console.log(line);
    console.log(result);
    if (resultRef.current) {
      resultRef.current.scrollIntoView();
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  L'application propose un test simple pour vérifier l'acuité visuelle à l'aide de votre appareil mobile. Une série de graphiques visuels contenant des lettres et des chiffres de différentes tailles s'affichera. Vous devrez identifier la lettre ou le chiffre que vous pouvez voir clairement à la distance spécifiée. Votre capacité à voir les petites lettres et chiffres sera évaluée pour déterminer votre acuité visuelle.
                </p>
                <p>Comment effectuer le test :</p>
                <ul>
                  <li>
                    Créez un environnement confortable : Assurez-vous d'être dans une zone avec un bon éclairage et un minimum de distractions. Réglez votre appareil à un niveau confortable.
                  </li>
                  <li>
                    Gardez la distance appropriée : Tenez votre appareil à environ 4 pieds (1,2 mètre) de vos yeux.
                  </li>
                  <li>
                    Couvrez un oeil à la fois : Utilisez votre main pour couvrir complètement un oeil pendant que vous effectuez le test sur l'autre.
                  </li>
                </ul>
                <p>Facteurs affectant la précision du test :</p>
                <ul>
                  <li>
                    Taille et qualité de l'écran : La taille et la qualité de l'écran peuvent affecter la précision du test.
                  </li>
                  <li>
                    Conditions d'éclairage : Un éclairage insuffisant ou excessif peut affecter votre capacité à voir les graphiques clairement.
                  </li>
                  <li>
                    Facteurs individuels : Des facteurs comme la fatigue oculaire, l'épuisement ou les maladies oculaires sous-jacentes peuvent affecter la précision du test.
                  </li>
                </ul>
                <p>
                  <b>
                    <u>Remarque importante :</u> Veuillez noter que ce test n'est pas un substitut à un examen complet des yeux par un professionnel de la santé. Il est recommandé de consulter un ophtalmologiste pour une évaluation précise de votre vision. Ce test est destiné à servir d'outil de dépistage initial. Si vous remarquez des changements dans votre vision, tels qu'une vision floue, une vision double ou des difficultés de lecture, il est essentiel de demander des soins professionnels.
                  </b>
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <div className="bg-warning text-black text-center p-3">
                  <p>
                    Veuillez sélectionner la ligne que vous ne pouvez pas lire clairement pour afficher le résultat
                  </p>
                </div>
                <hr />
                <div className="list-group">
                  {lines.map((line, index) => (
                    <div
                      key={index}
                      onClick={() => handleRowClick(line)}
                      className="list-group-item"
                      style={{
                        fontSize: line.size,
                        cursor: "pointer",
                        textAlign: "center",
                        border: "2px solid transparent",
                        borderRadius: "8px",
                        padding: "8px",
                        marginBottom: "10px",
                      }}
                    >
                      {line.text}
                    </div>
                  ))}
                </div>
                {result && (
                  <div
                    ref={resultRef}
                    className={`alert ${
                      result.test === "good" ? "alert-success" : "alert-warning"
                    } mt-4`}
                  >
                    <h4>Résultat : {result.value}</h4>
                    {result.advice && <p>{result.advice}</p>}
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">Informations supplémentaires</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Qu'est-ce que le test de Snellen ?</h2>{" "}
                  </u>
                  <p>
                    Le test de Snellen est un examen d'acuité visuelle qui mesure la capacité à voir les détails fins.
                  </p>
                  <p>
                    Le test se compose de plusieurs lignes contenant des lettres de différentes tailles.
                  </p>
                  <p>Plus vous pouvez lire de petites lettres, meilleure est votre acuité visuelle.</p>
                  <div className="p-3 mb-2 bg-info  ">Exemple d'un résultat 6/6</div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Comment interpréter les résultats</h2>{" "}
                  </u>
                  <p>L'acuité visuelle est déterminée par la plus petite ligne que la personne peut lire.</p>
                  <ul>
                    <li>
                      20/20 signifie que la personne peut lire ce qu'on s'attend à voir à la personne moyenne à 20 pieds.
                    </li>
                    <li>
                      20/40 signifie que la personne doit se rapprocher à la moitié de la distance pour voir ce que la personne moyenne peut voir à 20 pieds.
                    </li>
                  </ul>
                  <p>
                    Plus le rapport est inférieur à 20/20, plus cela indique une faiblesse de la vision.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Exemple de résultat : 20/40
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Questions fréquemment posées</h2>{" "}
                  </u>
                  <p>L'acuité visuelle peut-elle être améliorée ?</p>
                  <ul>
                    <li>
                      Oui, par le biais de lunettes, de lentilles de contact ou de chirurgie.
                    </li>
                    <li>Que signifie un résultat de 6/60 ?</li>
                    <li>Cela signifie que la personne souffre d'une faiblesse visuelle grave.</li>
                  </ul>
                  <b>Exemple</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Résultat : 6/60
                  </div>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Correction visuelle : lunettes, lentilles ou chirurgie ?</h3></div>
              <div className="info-section-body">
                <p>Les trois principales solutions pour corriger un défaut visuel sont les lunettes, les lentilles de contact et la chirurgie réfractive (laser). Les lunettes sont la solution la plus simple et la moins risquée. Les lentilles offrent plus de liberté mais nécessitent une hygiène rigoureuse. La chirurgie au laser (LASIK, PKR) corrige de façon permanente la myopie, l'hypermétropie et l'astigmatisme, sous réserve d'être éligible (cornée suffisamment épaisse, prescription stable depuis 2 ans).</p>
                <ul>
                  <li><strong>Myopie :</strong> vision floue de loin, corrigée par verres divergents</li>
                  <li><strong>Hypermétropie :</strong> vision floue de près, corrigée par verres convergents</li>
                  <li><strong>Astigmatisme :</strong> vision déformée, corrigée par verres toriques</li>
                  <li><strong>Presbytie :</strong> perte de la vision de près après 40 ans, corrigée par verres progressifs</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Fréquence des contrôles ophtalmologiques</h3></div>
              <div className="info-section-body">
                <p>En France, il est recommandé de consulter un ophtalmologiste tous les 2 ans en l'absence de problème particulier, et chaque année après 50 ans pour dépister glaucome, cataracte et DMLA (dégénérescence maculaire liée à l’âge). Les enfants doivent être examinés dès la naissance, à 9 mois, 2 ans et avant l'entrée en maternelle. Les personnes diabétiques doivent avoir un examen annuel du fond d'oeil pour dépister la rétinopathie diabétique.</p>
              </div>
            </div>
          </div>
        </div>
         </div>
    </div>
  );
}
export default Calculator;
